

/**
	* replaces VariantRadios defined by shopify
	*/

window.addEventListener('DOMContentLoaded', () => {

	class LMVariantSelects extends VariantSelects {
	
		#variants;
		#options;
	
		constructor() 
		{
			super();
     
			const variantCont = this.querySelector('script[type="application/json"][data-source="variants"]');
			this.#variants = JSON.parse( variantCont.textContent || variantCont.innerText );
	
			const optionsCont = this.querySelector('script[type="application/json"][data-source="product-options"]');
			this.#options = JSON.parse( optionsCont.textContent || optionsCont.innerText );

      this.addEventListener('change', this.updateVariantStatuses);

 			//options
			this.updateColorSort();
			this.updateSizeOptionVisibility();
			this.addListeners();
			this.showOptionTitles();
			this.selectFirstAvailable();
		};

		updateVariantStatuses() {

				const selectedOptionOneVariants = this.#variants.filter(
					(variant) => this.querySelector(':checked').value === variant.option1
				);
				
				const inputWrappers = [...this.querySelectorAll('.product-form__input')];

				inputWrappers.forEach((option, index) => {

					if (index === 0) return;

					const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
					const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;

					const availableOptionInputsValue = selectedOptionOneVariants
					  .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
					  .map((variantOption) => variantOption[`option${index + 1}`]);

    				this.setInputAvailability(optionInputs, availableOptionInputsValue);
				});
		};

		/** taken from stock VariantRadios and tweaked for input.disabled **/
		setInputAvailability(listOfOptions, listOfAvailableOptions) {

			listOfOptions.forEach((input) => {

				if (listOfAvailableOptions.includes(input.getAttribute('value'))) 
				{
					input.classList.remove('disabled');
					input.disabled = false;
				} 
				else 
				{
					input.classList.add('disabled');
					input.disabled = true;
				}

			});

				this.updateSizeOptionVisibility();
		}

			updateSizeOptionVisibility() {

				const largeSet = ['1X','2X','3X','4X'];

				const optIdx = this.#options.indexOf('Size');
				if (optIdx === -1) return false;	
		
				const sizeObj = {};

				//remap our options to keyed by size name
				this.#variants.forEach(variant => {
					const size = variant.options[optIdx];
					sizeObj[size] = sizeObj[size] ? sizeObj[size] + (variant.available ? 1 : 0) : (variant.available ? 1 : 0);
				});
              
				const xxsField = this.querySelector('.product-form__input--pill input[value="XXS"]');

				//just hide XXS outright if it's out of stock
				if (xxsField)
				{
					if (sizeObj['Extra Extra Small'] == '0') xxsField.classList.add('hidden');
					else xxsField.classList.remove('hidden');
				}

				//if one of our large sizes is out of stock, and all of the sizes afer it are out of stock, then hide it totally
				largeSet.forEach((size, index) => {

					const field = this.querySelector('.product-form__input--pill input[value="' + size + '"]');

					if (field)
					{
						const isAvailable = sizeObj[size] > 0;
						const remainingItems = largeSet.slice(index + 1);
						let allFollowingOutOfStock = true;

						//loop through rest of the items.	If any of them have inventory then bail and show the size selector
						remainingItems.some( nextSize => {
							if (sizeObj[nextSize] > 0) 
							{
								allFollowingOutOfStock = false;
								return true;
							}
						});
						
						if (!isAvailable && allFollowingOutOfStock) field.classList.add('hidden');
						else field.classList.remove('hidden');
					}
					
				});
					
			};

			
		/** taken from stock VariantRadios **/
		updateOptions() 
		{
			const fieldsets = Array.from(this.querySelectorAll('fieldset'));
			this.options = fieldsets.map((fieldset) => {
				return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
			});
		}
	
		/**
			* show the selected radio value next to the option title
			*/
		showOptionTitles()
		{
			this.querySelectorAll('input[type="radio"]:checked').forEach( radio => {
				this.setTitleForRadio(radio);
			});
		};
	
		updateColorSort() {
	
			const optIdx = this.#options.indexOf('Color');
			if (optIdx === -1) return false;	
		
			const colorObj = {};
			const colorRadios = this.querySelectorAll('.product-form__input--swatch input'); //input[type="radio"][name="Color"]');
		
			this.#variants.forEach(variant => {
				const color = variant.options[optIdx];
				colorObj[color] = colorObj[color] ? colorObj[color] + (variant.available ? 1 : 0) : (variant.available ? 1 : 0);
			});
        
			const sorted = Object.entries(colorObj).sort((a, b) => b[1] - a[1]).map(el => el[0]);
		
			sorted.forEach((color, idx) => {
				const radio = Array.from(colorRadios).find(r => r.value === color);
				if (radio) {
					const label = radio.parentNode.querySelector(`label[for="${radio.id}"]`);
 
                  if (label) 
                    {                      
                      label.style.order = idx;
                      
                      const quantity = colorObj[color];
                      if (quantity == '0') label.style.display = 'none';
                    }
				}
			});
		};
			
		addListeners()
		{
			this.querySelectorAll('input[type="radio"]').forEach( radio => {
				radio.addEventListener('change',(evt) => this.handleOptionChange(evt) );
			});
	
			this.querySelectorAll('fieldset > label').forEach( label => {
			 
				label.addEventListener('click',(evt) => {
				
					const radio = label.parentNode.querySelector('#' + label.getAttribute('for') );
				
					if (radio.disabled == true || radio.classList.contains('disabled'))
					{
						evt.preventDefault();
						evt.stopPropagation();
					}
				});
			});
	
		};
	
		handleOptionChange(evt)
		{
			this.setTitleForRadio(evt.target);
			this.selectFirstAvailable();
		};
		
		//select the first available option that's not disabled	
		selectFirstAvailable()
		{
			//get us off the main loop
			setTimeout( () => {		
	
				//make sure the current selected radio isn't disabled. If it is, find the first one that isn't and select it
				this.querySelectorAll('input[type="radio"]:checked').forEach( radio => {
	
					if (radio.disabled == true || radio.classList.contains('disabled'))
					{
						const goodRadio = radio.parentNode.querySelector('input[type="radio"]:not(:disabled):not(.disabled)');
						goodRadio.checked = true;
						goodRadio.dispatchEvent( new Event('change', { bubbles: true }) );
					}
				});
	
			},1);
		};
		
		setTitleForRadio(radio)
		{
			return;
 			const titleCont = radio.parentNode.querySelector('legend.form__label'); 
 			const dataCont = titleCont.querySelector('span');

 			//have to use the label for Size since we do some server-side rewrites of the label name
 			const lblStr = radio.name.includes('Size') ? radio.nextElementSibling.textContent : radio.value;

 			dataCont.dataset.selectedValue = lblStr;
 			dataCont.textContent = lblStr;
		};
	
	};

	//	
	customElements.define('variant-selects', LMVariantSelects);
	
});
	

window.addEventListener('DOMContentLoaded', () => {
	new LMProductDisplay();
});

class LMProductDisplay
{
	constructor() 
	{
		//metafields
		this.setupMetafields();
		this.setupVisibility();

		//media gallery
		this.checkThumbnailStripHeight();
		window.addEventListener('resize',() => this.checkThumbnailStripHeight() );
	};

	/**
		* metafield info (model, material, etc)
		*/
	setupMetafields()
	{
		//
		this.hideEmptyAccordions();
		
		//
		document.querySelectorAll('.product__accordion').forEach( item => {

			const tf = item.querySelector('.metafield-multi_line_text_field');
			if (tf) tf.innerHTML = tf.textContent;
			 
		});
	};

	hideEmptyAccordions()
	{
		const accordions = document.querySelectorAll('.product__accordion');

		accordions.forEach( acc => {

			const content = acc.querySelector('.accordion__content');
				
			if (content.textContent.trim().length == 0)
			{
				acc.style.display = 'none';
			}	
		})		
	};

	/**
		* media gallery stuff
		*/
	setupVisibility()
	{
		document.querySelectorAll('.thumbnail-list button.thumbnail').forEach( item => {
			item.addEventListener('click', (evt) => this.checkVisibility(evt) );
		});
		
	};

	checkVisibility(evt)
	{		
		//we only need to work on the vertical slider
		if (window.innerWidth < 990) return;

		const item = evt.target.closest('li');
		item.scrollIntoView({behavior: "smooth", block: "nearest", inline: "nearest"});		
	};

	checkThumbnailStripHeight()
	{		
		//we only need to work on the vertical slider
		if (window.innerWidth < 990) return;

		const sliderComp = document.querySelector('slider-component.thumbnail-slider');
		const sliderImg = document.querySelector('ul.product__media-list');

		if (sliderComp) sliderComp.style.maxHeight = sliderImg.clientHeight + 'px';
	};

};


class ProductSizeChart {

	#link = null;
	#chart = null;
	#url = null;
	#content = null;

	constructor(url) {

		this.#url = url;
		this.#link = document.querySelector('#size-chart-link');
		this.#chart = document.querySelector('#size-chart');

		const main = document.querySelector('main');
		main.prepend(this.#chart);

		this.#link.addEventListener('click',() => this.toggleChart());
		this.#chart.querySelector('.close').addEventListener('click',() => this.toggleChart());
	};

	chartIsVisible()
	{
		return this.#chart.classList.contains('is-visible');
	};

	showChart()
	{
		this.#chart.classList.add('is-visible');
	};

	hideChart()
	{
		this.#chart.classList.remove('is-visible');
	};
	
	toggleChart()
	{
		if ( this.chartIsVisible() )
		{
			this.hideChart();
		}
		else
		{
			if (this.#content != null)
			{
				this.showChart();
			}			
			else
			{
				//get the product data as json
				fetch(this.#url)
					.then(response => response.text() )
					.then(data => { 

						const container = document.querySelector('.size-chart-content');
						if (container) container.innerHTML = data;

						this.showChart();

					}).catch(e => { console.error(e); } );
			}

		}

	};
	
};

